import { defineComponent as _defineComponent } from 'vue'
import { computed, reactive, watch } from 'vue';
import { FormValidation } from 'ah-common-lib/src/form/interfaces';
import TermsAcceptanceForm from '../../registration/forms/common/TermsAcceptanceForm.vue';
import OBOSettingsForm from '../../registration/forms/common/OBOSettingsForm.vue';
import { AuthorityType, Client, Permission } from 'ah-api-gateways';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { getServices } from '@/app/services';
import { forkJoin } from 'rxjs';
import { useAuthStore } from '@/app/store/authStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'SignatoryTermsReview',
  props: {
    client: null,
    withOBOPermissions: { type: [Boolean, String], default: false }
  },
  emits: ["approved"],
  setup(__props: any, { emit }: { emit: ({ (e: 'approved'): void }), expose: any, slots: any, attrs: any }) {

const props = __props as { client: Client, withOBOPermissions: boolean | string };

const requestManager = useRequestManager().manager;

const services = getServices();





const authStore = useAuthStore();

const state = reactive<{
  termsValidation: FormValidation | null;
  oboValidation?: FormValidation<Permission[]>;
  permissions: Permission[];
}>({
  permissions: [
    { authority: AuthorityType.PAY_ON_BEHALF_OF, allow: false },
    { authority: AuthorityType.TRADE_ON_BEHALF_OF, allow: false },
  ],
  termsValidation: null,
});

const anyInvalid = computed(() => state.termsValidation?.$invalid || state.oboValidation?.$invalid);

function hasPermission(authority: AuthorityType) {
  return !!props.client.permissions?.find((p) => p === authority);
}

const clientId = computed(() => authStore.loggedInIdentity!.client!.id);

function savePermissions() {
  if (props.withOBOPermissions !== false) {
    return requestManager
      .cancelAndNew(
        'savePermissions',
        forkJoin(state.permissions.map((p) => services.authz.setClientsPermissions(clientId.value, p)))
      )
      .toPromise();
  }
  return Promise.resolve();
}

function approveClient() {
  return requestManager
    .sameOrCancelAndNew('approveClient', services.client.acceptTermsAndConditions(props.client.id))
    .toPromise();
}

function submit() {
  savePermissions()
    .then(approveClient)
    .then(() => emit('approved'));
}

watch(
  () => props.client,
  () => {
    state.permissions.forEach((p) => {
      p.allow = hasPermission(p.authority);
    });
  },
  { immediate: true }
);

return { __sfc: true,requestManager, services, props, emit, authStore, state, anyInvalid, hasPermission, clientId, savePermissions, approveClient, submit, TermsAcceptanceForm, OBOSettingsForm }
}

})